import { z } from "zod";

export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

/** page/limit pagination, uniform across every list endpoint. */
export const paginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});

export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

export const paginationMetaSchema = z.object({
  page: z.number().int().min(1),
  limit: z.number().int().min(1),
  total: z.number().int().min(0),
  totalPages: z.number().int().min(0),
  hasNextPage: z.boolean(),
});

export type PaginationMeta = z.infer<typeof paginationMetaSchema>;

/**
 * Envelope shared by every list endpoint.
 *
 * A wrapper rather than a bare array: a top-level JSON array cannot grow a
 * field, and pagination has to live somewhere the client can read without
 * parsing headers.
 */
export function paginatedSchema<TItem extends z.ZodType>(item: TItem) {
  return z.object({
    data: z.array(item),
    pagination: paginationMetaSchema,
  });
}

export interface Paginated<TItem> {
  data: TItem[];
  pagination: PaginationMeta;
}

/** Free-text filter accepted by the list endpoints that support searching. */
export const searchQuerySchema = z.object({
  search: z.string().trim().min(1).max(120).optional(),
});
